import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";


// ✅ Load Notifications
export async function loadNotificationsApi(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}notificationapis/get_notifications`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}


// ✅ Mark Read
export async function markNotificationRead(notification_id) {
  try {
    const fd = new FormData();
    fd.append("notification_id", notification_id);

    const res = await axios.post(`${apiBaseUrl}notificationapis/mark_read`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}


// ✅ Mark All Read
export async function markAllNotificationsRead(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}notificationapis/mark_all_read`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch {
    return { status: false };
  }
}
